<template>
    <input v-validate="'required'" name="time" type="text" :placeholder="placeholderText" v-model="value">
</template>

<script>
export default {
  data () {
    return {
      value: this.$moment(this.time, 'HH:mm:ss').format('HH:mm'),
      placeholderText: this.placeholder
    }
  },
  props: {
    time: {
      default: '00:00:00',
      type: String,
      required: false
    },
    placeholder: {
      default: '',
      type: String,
      required: false
    }
  },
  watch: {
    value (val) {
      this.$emit('update:time', val + ':00')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/TimeInput.vue